module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Coming soon":"Coming soon"},"zh":{"Coming soon":""}}')
  delete Component.options._Ctor
}
